import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import { Button } from '../Button';

export const SubscribeButton = styled(Button)<{ iconOnlyMobile?: boolean; active?: boolean }>`
  ${mediaQuery(BREAKPOINTS.medium)} {
    ${(props) =>
      props.iconOnlyMobile &&
      `
    cursor: pointer;
    height: 40px;
    position: relative;
    background-color: ${props.theme.color.light.default};

    div {
      margin-left: 0;
      margin-right: 0;
    }

    svg {
      color: ${props.theme.color.purple.default};
      font-size: 28px;
    }

    span, img {
      display: none;
    }
  `}

    ${(props) =>
      props.iconOnlyMobile &&
      props.active &&
      `
      background-color: ${props.theme.color.blue.default};

    svg {
      color: ${props.theme.color.light.default};  
    }  
    `}
  }
`;
